import React from 'react';
import { StyledFormLogoContainer } from './FormLogo.styled';
import { AppLogo } from '../../AppLogo/AppLogo';

export const FormLogo: React.FC = () => {
  return <StyledFormLogoContainer>
    <AppLogo />
  </StyledFormLogoContainer>;
}